// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"vO","reco":"wO","products":"xO"};